module.exports = __webpack_public_path__ + "img/bot_intent_shibie_ac.dc3cda6b.svg";